import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import HeaderDash from '../HeaderDashNew';
import Footer from '../Footer';
import './Team.css'; // Ensure correct CSS import
import UserAuthContext from '../../../context/UserAuthContext';

interface Downline {
  user_name: string;
  wallet_address: string;
  joined_at: string;
}

const Team: React.FC = () => {
  const { userData } = useContext(UserAuthContext);
  const [downlines, setDownlines] = useState<Downline[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedZone, setSelectedZone] = useState<string>('premium'); // Default zone
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const fetchTeamData = async (userId: number, zone: string) => {
    setLoading(false);
  };

  useEffect(() => {
    console.log(userData);
    if (userData?.id) {
      fetchTeamData(Number(userData.id), selectedZone);
    }
  }, [userData, selectedZone]);

  const handleZoneChange = (zone: string) => {
    setSelectedZone(zone);
    setLoading(true); // Show loading during data fetch
  };

  if (loading) {
    return <div className="team-loading">Loading team data...</div>;
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDownlines = userData?.direct_referrals.slice(indexOfFirstItem, indexOfLastItem) || [];
  const totalPages = Math.ceil((userData?.direct_referrals.length || 0) / itemsPerPage);

  return (
    <div className="team-page">
      <HeaderDash />
      <div className="team-main-content">
        <h1>Your Team</h1>
        <h4>Total Members: {userData?.direct_referrals.length}</h4>

        <div className="team-table-wrapper">
          <table className="team-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email Address</th>
                <th>Premium Downline</th>
                <th>Rainmaker Downline</th>
                <th>Direct Referrals</th>
              </tr>
            </thead>
            <tbody>
              {currentDownlines.map((downline, index) => (
                <tr key={index}>
                  <td>{downline.user_name}</td>
                  <td>{downline.email}</td>
                  <td>{downline.premium_downline_count}</td>
                  <td>{downline.rainmaker_downline_count}</td>
                  <td>{downline.team_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination-wrapper">
          <div className="pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
            >
              Prev
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              Next
            </button>
          </div>
          <div className="jump-to-page">
            <label htmlFor="jumpToPage">Jump to page:</label>
            <input
              id="jumpToPage"
              type="number"
              min="1"
              max={totalPages}
              value={currentPage}
              onChange={(e) => {
                const newPage = Number(e.target.value);
                if (newPage >= 1 && newPage <= totalPages) {
                  setCurrentPage(newPage);
                }
              }}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Team;